import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

import { withDefaults } from 'vue'
interface Props {
  list?: []
  checkId?:string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    list: { default: () => {
    return []
  } },
    checkId: { default: '' }
  },
  emits: ["checkListId"],
  setup(__props: any, { emit }: { emit: ({(e: 'checkListId', id: number): void}), expose: any, slots: any, attrs: any }) {



const menuItemClick = (id:number) => {
  emit('checkListId', id)
}


return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu_item_group = _resolveComponent("el-menu-item-group")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_aside = _resolveComponent("el-aside")!

  return (__props.list && __props.list.length)
    ? (_openBlock(), _createBlock(_component_el_aside, {
        key: 0,
        width: "200px",
        class: "aside-container"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_scrollbar, { height: "100%" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu, {
                "unique-opened": "",
                class: "i-el-menu"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id
                    }, [
                      (item.sub && item.sub.length > 0)
                        ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                            key: 0,
                            index: item.id.toString()
                          }, {
                            title: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(item.name), 1)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_el_menu_item_group, null, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sub, (item2) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: item2.id
                                    }, [
                                      (!item2.sub || item2.sub.length <= 0)
                                        ? (_openBlock(), _createBlock(_component_el_menu_item, {
                                            key: 0,
                                            style: _normalizeStyle('padding-left: 46px; color:'+ (__props.checkId === item2.id? '#E31E52' : '#333')),
                                            class: _normalizeClass(['i-menu-item', __props.checkId === item2.id?'active':'']),
                                            index: item2.id.toString(),
                                            onClick: ($event: any) => (menuItemClick(item2.id))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item2.name) + " " + _toDisplayString(item2.length), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["style", "class", "index", "onClick"]))
                                        : (_openBlock(), _createBlock(_component_el_sub_menu, {
                                            key: 1,
                                            class: "i-sub-menu",
                                            index: item2.id.toString()
                                          }, {
                                            title: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item2.name), 1)
                                            ]),
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.sub, (item3) => {
                                                return (_openBlock(), _createBlock(_component_el_menu_item, {
                                                  class: _normalizeClass(['i-menu-item', __props.checkId === item3.id?'active':'']),
                                                  style: _normalizeStyle('padding-left: 60px; color:'+ (__props.checkId === item3.id? '#E31E52' : '#333')),
                                                  key: item3.id,
                                                  index: item3.id.toString(),
                                                  onClick: ($event: any) => (menuItemClick(item3.id))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(item3.name), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["class", "style", "index", "onClick"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["index"]))
                                    ]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["index"]))
                        : (_openBlock(), _createBlock(_component_el_menu_item, {
                            key: 1,
                            class: _normalizeClass(['i-menu-item', __props.checkId === item.id?'active':'']),
                            style: _normalizeStyle('padding-left: 32px; color:'+ (__props.checkId === item.id? '#E31E52' : '#333')),
                            index: item.id.toString(),
                            onClick: ($event: any) => (menuItemClick(item.id))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["class", "style", "index", "onClick"]))
                    ]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})